import { Form, Input } from '~/shared/components/form';
import { UseFormReturn } from 'react-hook-form';

import { Fields, LoginInputs } from '../models/fields';
import { Container, StyledCTAButton } from '../styled';
import { TranslationKey } from '~/lib';

type ForgotPasswordViewProps = {
    methods: UseFormReturn<LoginInputs>;
    handleResetSendEmail: (payload: LoginInputs) => Promise<void>;
    translate: (key: TranslationKey) => string;
};

export const ForgotPasswordView = ({
    methods,
    handleResetSendEmail,
    translate,
}: ForgotPasswordViewProps) => {
    const enableButton = methods.formState.isDirty && methods.formState.isValid;

    return (
        <>
            <Form methods={methods} onSubmit={handleResetSendEmail}>
                <Container>
                    <Input
                        data-testid="email"
                        name={Fields.Email}
                        autoComplete="email"
                        placeholder={translate('login.email')}
                        required
                    />
                    <StyledCTAButton
                        disabled={!enableButton}
                        data-testid="reset-password-button"
                        type="submit"
                        variant="primary"
                    >
                        {translate('login.resetPassword')}
                    </StyledCTAButton>
                </Container>
            </Form>
        </>
    );
};
